var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2225 11.7336C15.1979 9.06491 17.4636 7.7666 17.5672 7.70615C16.284 5.88205 14.2951 5.63282 13.5962 5.61295C11.9257 5.44155 10.3054 6.58751 9.45446 6.58751C8.58653 6.58751 7.27616 5.62951 5.86387 5.65766C4.0465 5.68498 2.34633 6.71089 1.41386 8.30397C-0.510513 11.5522 0.924701 16.3257 2.7684 18.9513C3.69067 20.2372 4.76836 21.673 6.17894 21.6225C7.55896 21.567 8.07444 20.7647 9.7398 20.7647C11.3899 20.7647 11.8739 21.6225 13.3125 21.5902C14.7936 21.567 15.7261 20.2985 16.6161 19.001C17.6819 17.5272 18.1099 16.0757 18.1269 16.0011C18.0921 15.9895 15.2505 14.9322 15.2225 11.7336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5049 3.88572C13.2472 2.98071 13.755 1.74946 13.614 0.5C12.5397 0.546368 11.1962 1.22451 10.4226 2.10965C9.7381 2.88963 9.12665 4.16807 9.28461 5.37034C10.4914 5.45811 11.7304 4.77666 12.5049 3.88572Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.89c560d58a1384b5a9c1b64f76dfc215.svg";
export { ForwardRef as ReactComponent };